// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__25cuH","inner":"Footer_inner__10XL0"};